import styled from 'styled-components';
import { ReactComponent as PicFlash } from '../../../assets/pictures/flash.svg';
import * as ReactDOMServer from 'react-dom/server';
import { CSSProperties } from 'react';

const svgString = encodeURIComponent(ReactDOMServer.renderToStaticMarkup(<PicFlash/>));

export const NoConnectionBackground = styled.div<{ background?: CSSProperties['background']; }>`
    background: ${({ background }) => background || `url("data:image/svg+xml,${svgString}")`};
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 16px;
    gap: 16px;
    
    .bg-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px;
        gap: 10px;
        width: 64px;
        height: 64px;
        background: var(--color-fill-attention);
        border-radius: 16px;
    }

    .title {
        font-weight: 600;
        font-size: 32px;
        line-height: 40px;
    }

    .description {
        font-size: 14px;
        line-height: 24px;
        color: var(--color-label-primary);
    }

    .retry-button {
        width: 160px;

        &.mobile {
            width: 100%;
        }
    }
`;
